import React from 'react';
import PropTypes from 'prop-types';
import useMobileBreakpoint from '../../../../hooks/useMobileBreakpoint';
import EnrollmentLegalProgressStepper from './EnrollmentLegalProgressStepper';
import EnrollmentLegalProgressCircle from './EnrollmentLegalProgressCircle';

const EnrollmentLegalProgress = ({ onBack }) => {
  const isMobile = useMobileBreakpoint();

  if (isMobile) {
    return <EnrollmentLegalProgressCircle onBack={onBack} />;
  }

  return <EnrollmentLegalProgressStepper onBack={onBack} />;
};
EnrollmentLegalProgress.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default EnrollmentLegalProgress;
